/**
 * @class
 */
const Events = GLOBAL.Events = Class( /** @lends Events.prototype */ {
    /**
     * @type {Object.<string, Object>} Listeners hash map
     * @protected
     */
    eventsSubscriptions: {},
    /**
     * @param {string} event Event name
     * @param {function} callback Event listener
     * @param {*} [context] Event listener context
     * @param {boolean=false} [prepend] Add to the end or top of listeners stack
     * @returns {Events}
     */
    on(event, callback, context, prepend) {
        if (!this.eventsSubscriptions[event]) {
            this.eventsSubscriptions[event] = [];
        }

        var method = prepend ? 'unshift' : 'push';

        this.eventsSubscriptions[event][method]({
            callback: callback,
            context: context,
            type: "on"
        });

        return this;
    },
    /**
     * @param {string} event Event name
     * @param {function} callback Event listener
     * @param {*} [context] Event listener context
     * @param {boolean=false} [prepend] Add to the end or top of listeners stack
     * @returns {Events}
     */
    once(event, callback, context, prepend) {
        if (!this.eventsSubscriptions[event]) {
            this.eventsSubscriptions[event] = [];
        }

        var method = prepend ? 'unshift' : 'push';

        this.eventsSubscriptions[event][method]({
            callback: callback,
            context: context,
            type: "once"
        });

        return this;
    },

    off(event, callback, context) {
        if (!event) {
            for (event in this.eventsSubscriptions) {
                if (this.eventsSubscriptions.hasOwnProperty(event)) {
                    this.off(event);
                }
            }
        } else {
            var subscriptions = this.eventsSubscriptions[event];

            if (subscriptions) {
                for (var i = 0, count = subscriptions.length; i < count; i++) {
                    if ((subscriptions[i].callback == callback || !callback) && (subscriptions[i].context == context || !context)) {
                        subscriptions.splice(i, 1);
                        break;
                    }
                }
            }
        }

        return this;
    },
    isSubscriptions(event) {
        return this.eventsSubscriptions[event];
    },
    /**
     * @param {string} event Event name.
     * @param {*} [args] Event arguments passed to listeners
     * @returns {Events}
     */
    emit(event, args) {
        var subscriptions = this.eventsSubscriptions[event];

        if (subscriptions) {
            var i, count;
            var callbacks = [];
            var context;

            for (i = 0, count = subscriptions.length; i < count; i++) {
                callbacks.push(subscriptions[i]);

                if (subscriptions[i].type == "once") {
                    subscriptions.splice(i, 1);
                    i--;
                    count--;
                }
            }

            for (i = 0, count = callbacks.length; i < count; i++) {
                try {
                    context = callbacks[i].context ? callbacks[i].context : this;
                    if (callbacks[i].callback.call(context, args, this) != null) {
                        break;
                    }
                } catch (e) {
                    console.error(e.stack, context, args, this);
                }
            }
        }

        return this;
    },
    /**
     * @param {string} event
     * @param {Array} args
     * @param {boolean} [sequentially=false]
     * @returns {Promise}
     *
     * warn: not completed!
     */
    emitAsync(event, args, sequentially) {
        var subscriptions = this.eventsSubscriptions[event],
            promise = Promise.resolve();

        if (_.isEmpty(subscriptions)) {
            return promise;
        }


        var listeners = _.map(subscriptions.slice(), (subscription, i) => {
            if (subscription.type === 'once') {
                subscriptions.splice(i, 1);
            }

            return subscription;
        });

        if (sequentially) {
            promise = Promise.reduce(
                listeners, (current, next) => next.callback.call(next.context || this, args, this)
            );
        } else {
            promise = Promise.map(
                listeners, (listener) => listener.callback.call(listener.context || this, args, this)
            );
        }

        return promise.catch((e) => {
            console.error(e.stack, context, args, this);
        });
    }
});

Events.Static( /** @lends Events */ {
    initialize() {
            this.eventsSubscriptions = {};
        },
        /**
         * @param {string} event Event name
         * @param {function} callback Event listener
         * @param {*} [context] Event listener context
         * @param {boolean=false} [prepend] Add to the end or top of listeners stack
         * @returns {Events}
         */
        on(event, callback, context, prepend) {
            if (!this.eventsSubscriptions[event]) {
                this.eventsSubscriptions[event] = [];
            }

            var method = prepend ? 'unshift' : 'push';

            this.eventsSubscriptions[event][method]({
                callback: callback,
                context: context,
                type: "on"
            });

            return this;
        },
        /**
         * @param {string} event Event name
         * @param {function} callback Event listener
         * @param {*} [context] Event listener context
         * @param {boolean=false} [prepend] Add to the end or top of listeners stack
         * @returns {Events}
         */
        once(event, callback, context, prepend) {
            if (!this.eventsSubscriptions[event]) {
                this.eventsSubscriptions[event] = [];
            }

            var method = prepend ? 'unshift' : 'push';

            this.eventsSubscriptions[event][method]({
                callback: callback,
                context: context,
                type: "once"
            });

            return this;
        },

        off(event, callback, context) {
            if (!event) {
                for (event in this.eventsSubscriptions) {
                    if (this.eventsSubscriptions.hasOwnProperty(event)) {
                        this.off(event);
                    }
                }
            } else {
                var subscriptions = this.eventsSubscriptions[event];

                if (subscriptions) {
                    for (var i = 0, count = subscriptions.length; i < count; i++) {
                        if ((subscriptions[i].callback == callback || !callback) && (subscriptions[i].context == context || !context)) {
                            subscriptions.splice(i, 1);
                            break;
                        }
                    }
                }
            }

            return this;
        },
        isSubscriptions(event) {
            return this.eventsSubscriptions[event];
        },
        /**
         * @param {string} event Event name.
         * @param {*} [args] Event arguments passed to listeners
         * @returns {Events}
         */
        emit(event, args) {
            var subscriptions = this.eventsSubscriptions[event];

            if (subscriptions) {
                var i, count;
                var callbacks = [];
                var context;

                for (i = 0, count = subscriptions.length; i < count; i++) {
                    callbacks.push(subscriptions[i]);

                    if (subscriptions[i].type == "once") {
                        subscriptions.splice(i, 1);
                        i--;
                        count--;
                    }
                }

                for (i = 0, count = callbacks.length; i < count; i++) {
                    try {
                        context = callbacks[i].context ? callbacks[i].context : this;
                        if (callbacks[i].callback.call(context, args, this) != null) {
                            break;
                        }
                    } catch (e) {
                        console.error(e.stack, context, args, this);
                    }
                }
            }

            return this;
        }
});
